import React from "react"
import { Jumbotron } from "../../components"
import bgMerchandise from "../../assets/img/bgMerchandise.png"
import InquiriesOrder from "./InquiriesOrder"
import JumbotronDesc from "./JumbotronDesc"
import MerchandiseList from "./MerchandiseList"

function Merchandise() {
  return (
    <>
      <Jumbotron bgImage={bgMerchandise}>
        <JumbotronDesc />
      </Jumbotron>
      <MerchandiseList />
      <InquiriesOrder />
    </>
  )
}

export default Merchandise
